<button
  *ngFor="let record of records; trackBy: trackByCorrelationId"
  class="conv-item"
  (click)="getChatHistory(record)"
  [class.is-selected]="record.correlation_id === selectedCard">

  <!-- Canal: círculo sólido color + ícono PrimeNG blanco -->
  <div class="conv-av" [style.background]="getChannelColor(record.channel)">
    <i [class]="getChannelIcon(record.channel) + ' conv-av-icon'"></i>
  </div>

  <!-- Cuerpo -->
  <div class="conv-body">
    <div class="conv-top">
      <span class="conv-name">{{ getDisplayName(record.name) }}</span>
      <span class="conv-time">{{ getRecordDate(record) }}</span>
    </div>
    <div class="conv-bottom">
      <span class="conv-preview">
        <span class="conv-author">{{ record.user_in_control ? record.user_in_control.name : 'Globot IA' }}:</span>
        {{ record.last_message | maxText }}
      </span>
      <span *ngIf="record.new_message" class="conv-unread"></span>
      <ng-container *ngIf="!record.new_message">
        <span *ngIf="record.user_in_control" class="conv-tag conv-tag--live">
          <span class="conv-dot-live"></span>{{ record.user_in_control.name.split(' ')[0] }}
        </span>
        <span *ngIf="!record.user_in_control" class="conv-tag conv-tag--ia">
          <img src="assets/icons/globot-icon.svg" width="12" height="11" alt="">IA
        </span>
      </ng-container>
    </div>
  </div>

</button>
